import React from "react";
import type {NextPage} from "next";
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import styled from "styled-components";
import WaveLayout from "../src/layouts/WaweLayout";
import {deviceMax} from "../styles/device";
import SssContent from "../src/components/sss/SssContent";

const SikcaSorulanSorular: NextPage = () => {
    return (
        <React.Fragment>

            <HtmlHead
                pageTitle={'Sıkça Sorulan Sorular | Pembe Panjur'}
                description={'Pembe Panjur hakkında bilmeniz gerekenler. Hesap işlemleri, üyelik, ücret, ödeme mesajlaşma ve daha pek çok konu hakkında bilgiler.'}
            />
            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} loginButtonText={true} hamburgerMenuType={'black'} loginButtonMenu={true}>
                <SssWrapper>
                    <SssContent/>
                </SssWrapper>
            </WaveLayout>

        </React.Fragment>
    )
}

const SssWrapper = styled.div`
  position: relative;
  padding: 0 19px 40px 19px;

  @media ${deviceMax.tablet} {
    padding: 70px 0 40px 0;
  }

`;

import { checkAuthAndRedirect } from '../src/utils/authHelper';
export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};

export default SikcaSorulanSorular;
